import { Compiler, Component, Injector, NgModule, SystemJsNgModuleLoader } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpModule, Http } from "@angular/http";
import { DialogModule, TooltipModule } from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";

import {
    TCI_APP_DETAIL_MENU_TYPE,
    TCITenantAppDetailsMenu,
    ITCITenantComponentOptions,
    TCI_COMPONENT_MODE
} from "@tci/common";
import {TCITenantMenuServices} from "../ng-tenant/tci-tenant.menu";
import {TciTenantModelService} from "../ng-tenant/tci-tenant.model";

import {NgAppListComponent} from "./ng-app-list.component";
import {NgAppListingComponent} from "./ng-app-listing/ng-app-listing.component";
import {NgAppListingRowComponent} from "./ng-app-listing/ng-app-listing-row/ng-app-listing-row.component";
import {NgAppListService} from "./ng-app-list.service";
import {NgAppCreateV2Module} from "./ng-app-create-v2/ng-app-create-v2.module";
import {NgWaitModule} from "../ng-shared/ng-components/ng-wait/ng-wait.module";
import {NgPaginatorModule} from "../ng-shared/ng-components/ng-paginator/ng-paginator.module";
import {NgSharedModule} from "../ng-shared/ng-shared.module";
import {BaseAppDetailComponentLoaderResolverInput} from "../ng-app-details/ng-app-details.component";
import {NgAppDetailsModule} from "../ng-app-details/ng-app-details.module";
import {NgAppDeployModule} from "../ng-app-deploy/ng-app-deploy.module";
import {NgHamburgerMenuModule} from "../ng-app-hamburger-menu/ng-app-hamburger-menu.module";
import {NgClickOutsideModule} from "../ng-shared/ng-directives/ng-click-outside/ng-click-outside.module";
import {TciTenantModule} from "../ng-tenant/tci-tenant.module";
import {TCITenantRemoteServices} from "../ng-tenant/tci-tenant-remote-services";
import {TciTenantService} from "../ng-tenant/tci-tenant.service";
import { NgUserService } from "../ng-shared/ng-services/ng-user.service";
import { TciTenantComponentCacheService } from "../ng-tenant/tci-tenant-component-cache.service";
import { TCIRouteSelectorResolver, TciTenantAppsRouteActivator } from "../tci-tenant-apps-route-activator";
// import { NgAppListResolver } from "./ng-app-list-resolver";
import { NgAppListHeaderModule } from "./ng-app-list-header/ng-app-list-header.module";
import { NgAppMonitoringModule } from "../ng-app-monitoring/ng-app-monitoring.module";
import { NgAppFeatureToggleService } from "../ng-shared/ng-services/ng-app-feature-toggle.service";
import { BaseAppListPeekService } from "./ng-app-listing/ng-app-list-peek/base-app-list-peek.service";
import { NgAppChangeNotificationService } from "../ng-shared/ng-services/ng-app-change-notification.service";
import { NgAuthGuardService } from "../ng-shared/ng-services/ng-auth-guard.service";
import { NgAppHMService } from "../ng-app-hamburger-menu/ng-app-hamburger-menu.service";

@Component({
    selector: "ng-dummy-component",
    template: ""
})
export class DummyComponent {
}

export function TciAppDetailsTenantRouteActivatorFactory(
    parentInjector: Injector,
    loader: SystemJsNgModuleLoader,
    compiler: Compiler,
    tenantRemoteServices: TCITenantRemoteServices,
    tenantSvc: TciTenantService,
    tenantCacheService: TciTenantComponentCacheService,
    tenantMenuSrv: TCITenantMenuServices,
    appsAPISrv: NgAppListService,
    userService: NgUserService,
    authSvc: NgAuthGuardService,
    router: Router,
    featureToggleService: NgAppFeatureToggleService) {
    const routeResolver: TCIRouteSelectorResolver = input => {
        const items = TCITenantAppDetailsMenu
            .getAllMenuItems(TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU)
            .filter(item => item.getRouteId() === input);
        if (items && items.length > 1) {
            throw new Error("Duplicate routes found for :" + input);
        }
        return items.pop();
    };


    const inputResolver: any = (input, apptype, compOptions: ITCITenantComponentOptions<any>) => {
        return appsAPISrv.getAppById(input, apptype).map(appData =>
            new BaseAppDetailComponentLoaderResolverInput(
                appData.type,
                compOptions.getComponentSelectorType(),
                appData,
                userService,
                featureToggleService,
                TCI_COMPONENT_MODE.COMP_MODE_APP_DEFAULT,
                undefined,
                null)
        );
    };

    return new TciTenantAppsRouteActivator(
        parentInjector,
        loader,
        compiler,
        tenantRemoteServices,
        tenantSvc,
        tenantCacheService,
        tenantMenuSrv,
        authSvc,
        router,
        routeResolver,
        inputResolver
    );
}

export function NgAppListServiceFactory(
    http: Http,
    tenantRemoteServices: TCITenantRemoteServices,
    appRefreshNotifSvc: NgAppChangeNotificationService,
    hmSvc: NgAppHMService
): NgAppListService {
    return NgAppListService.getInstance(http, tenantRemoteServices, appRefreshNotifSvc, hmSvc);
}

export function BaseAppListPeekServiceFactory(
    http: Http, notificationSvc: NgAppChangeNotificationService, tenantMenuSrv: TCITenantMenuServices
): BaseAppListPeekService {
    return BaseAppListPeekService.getInstance(http, notificationSvc, tenantMenuSrv);
}

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        NgAppCreateV2Module,
        NgAppDetailsModule,
        NgWaitModule,
        NgSharedModule.forRoot(),
        ReactiveFormsModule,
        TooltipModule,
        NgAppDeployModule,
        NgPaginatorModule,
        NgHamburgerMenuModule,
        NgClickOutsideModule,
        NgAppMonitoringModule,

        // Tenant Import Module setup
        HttpModule,
        TciTenantModule,
        NgAppListHeaderModule
    ],
    declarations: [
        DummyComponent,
        NgAppListComponent,
        NgAppListingComponent,
        NgAppListingRowComponent
    ],
    exports: [
        DummyComponent,
        NgAppListComponent,
        NgAppListingComponent,
        NgAppListingRowComponent,
        NgAppMonitoringModule
    ],
    providers: [
        {
            provide: NgAppListService,
            useFactory: NgAppListServiceFactory,
            deps: [
                Http,
                TCITenantRemoteServices,
                NgAppChangeNotificationService,
                NgAppHMService
            ]
        },
        {
            provide: TciAppDetailsTenantRouteActivatorFactory,
            useFactory: TciAppDetailsTenantRouteActivatorFactory,
            deps: [
                Injector,
                SystemJsNgModuleLoader,
                Compiler,
                TCITenantRemoteServices,
                TciTenantService,
                TciTenantComponentCacheService,
                TCITenantMenuServices,
                NgAppListService,
                NgUserService,
                NgAuthGuardService,
                Router,
                NgAppFeatureToggleService
            ]
        },
        {
            provide: BaseAppListPeekService,
            useFactory: BaseAppListPeekServiceFactory,
            deps: [
                Http,
                NgAppChangeNotificationService,
                TCITenantMenuServices
            ]

        }
    ]
})
export class NgAppListModule {
    constructor(private translate: TranslateService) {
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang("en");

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use("en");
    }
}
